import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  Pagination,
  Select,
  Table,
  TableColumnsType,
} from "antd";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UI_ITOModuleTitle } from "../../UI_ITO/indexUI";
import { selectViewShowBy } from "../../constants/selectViewShowBy";
import { IConstructorJsxFilteredLisTManager } from "../../interfaces/Constructor/IConstructorJsxFilteredLisTManager";
import { IListManagerTable } from "../../interfaces/IListManagerTable";
import { IManager } from "../../interfaces/IManager";
import { useArchiveManagerMutation } from "../../store/api/listManager.api";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import {
  SELECT_LIST_MANAGER_ACTIVE,
  SELECT_LIST_MANAGER_ARCHIVE,
  SELECT_MANAGER,
  SELECT_MANAGER_BY_ID,
} from "../../store/selectors/listManagerSelector";
import {
  CHANGE_MANAGER_FORM_TYPE,
  MANAGER_ARCHIVE,
} from "../../store/slice/listManagerSlice/listManagerSlice";

import classes from "./PageListManager.module.css";

/**
 * Компонент страницы списка менеджеров.
 */
export function PageListManager(): ReactElement {
  const { id } = useParams();
  const findManager = useAppSelector(
    SELECT_MANAGER_BY_ID(id ? +id : undefined),
  );
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const listManagerActive = useAppSelector(SELECT_LIST_MANAGER_ACTIVE);
  const listManagerArchive = useAppSelector(SELECT_LIST_MANAGER_ARCHIVE);
  const selectedManager = useAppSelector(SELECT_MANAGER);
  const [filteredListManagerActive, setFilteredListManagerActive] =
    useState<IManager[]>(listManagerActive);
  const [archiveMananger] = useArchiveManagerMutation();
  const nameParts = [
    selectedManager?.surname,
    selectedManager?.name,
    selectedManager?.patronymic,
  ]?.filter(Boolean);

  function changeSelectedManager(managerId: string | number) {
    navigate(`/manager/${managerId}`);
  }

  // отображение менеджеров в архивном и активном списке, установка найденного пользователя
  useEffect(() => {
    setFilteredListManagerActive(listManagerActive);
  }, [listManagerActive, listManagerArchive]);

  function handleSearch(value: string) {
    setFilteredListManagerActive(() => {
      if (value) {
        return listManagerActive.filter(
          (manager: IManager) =>
            manager?.name?.toLowerCase().includes(value.toLowerCase()) ||
            manager?.surname?.toLowerCase().includes(value.toLowerCase()) ||
            manager?.patronymic?.toLowerCase().includes(value.toLowerCase()),
        );
      } else {
        return listManagerActive;
      }
    });
  }

  const columnsApplication: TableColumnsType<IListManagerTable> = [
    {
      key: "1",
      title: "ФИО",
      dataIndex: "manager",
      render: (item) => (
        <span
          className={classes.columnManager}
          onClick={() => {
            changeSelectedManager(item.manager.id);
          }}
        >
          {item.fullName}
        </span>
      ),
    },
    {
      key: "2",
      title: "Телефон",
      dataIndex: "phoneNumber",
    },
    {
      key: "3",
      title: "Адрес эл.почты",
      dataIndex: "email",
    },
  ];

  const dataTableManagerSource: IListManagerTable[] =
    filteredListManagerActive?.map((item: IManager) => {
      const { id, surname, name, patronymic, email, phone_number, is_enabled } =
        item;

      return {
        key: id,
        manager: {
          fullName: `${surname || ""} ${name || ""} ${patronymic || ""}` || "",
          manager: item,
        },
        phoneNumber: phone_number,
        email: email,
      };
    });

  return (
    <div className={classes.managers}>
      <div className={classes.managers__header}>
        <UI_ITOModuleTitle title="Менеджеры" />
        <div className={classes.managers__filters}>
          <Input
            className={classes.managers__input}
            placeholder="Введите контактный email"
            size="large"
            allowClear
            suffix={<SearchOutlined className={classes.managers__inputIcon} />}
            onChange={(event) => handleSearch(event.target.value)}
          />

          <Input
            className={classes.managers__input}
            placeholder="Телефон"
            size="large"
            allowClear
            suffix={<SearchOutlined className={classes.managers__inputIcon} />}
            onChange={(event) => handleSearch(event.target.value)}
          />

          <Button
            className={classes.managers__resetButton}
            type="primary"
            size="large"
          >
            Сбросить фильтр
            <CloseOutlined className={classes.managers__resetIcon} />
          </Button>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          className={classes.managers__create_manage_button}
          onClick={() => navigate("/user-create")}
        >
          Создать менеджера
        </Button>
      </div>

      <Table
        className={classes.managers__table}
        columns={columnsApplication}
        dataSource={dataTableManagerSource}
        size="small"
        pagination={false}
      />
      <div className={classes.pagination}>
        <label className={classes.pagination__label}>
          Показывать по
          <Select
            className={classes.pagination__select}
            options={selectViewShowBy}
          />
        </label>
        <Pagination
          className={classes.pagination__list}
          total={10}
          defaultPageSize={2}
        />
      </div>
    </div>
  );
}
